
export default {
  name: "HomeLogo",
};
